// Centralised page-content fetcher. Returns null while loading.
import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cache = null;
let inflight = null;
const subs = new Set();

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/page-content").then(({ data }) => {
      cache = data;
      subs.forEach((fn) => fn(data));
      return data;
    }).finally(() => { inflight = null; });
  }
  return inflight;
};

export function invalidatePageContent() {
  cache = null;
}

export function usePageContent() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) load().then((d) => { if (alive) setData(d); });
    subs.add(setData);
    return () => { alive = false; subs.delete(setData); };
  }, []);
  return data;
}
